import type { ActivityType } from "@opensea/graphql"
import type { ActivityFeedColumnControls } from "./types"

export const ACTIVITY_FEED_PAGE_SIZE = 32

export const DEFAULT_ACTIVITY_FEED_COLUMNS: ActivityFeedColumnControls = {
  event: true,
  item: true,
  price: true,
  quantity: true,
  rarity: true,
  from: true,
  to: true,
  time: true,
}

export const ORDERED_ACTIVITY_TYPES = [
  "SALE",
  "LISTING",
  "OFFER",
  "TRANSFER",
  "MINT",
] as const satisfies ActivityType[]
